import { Extract, ExtractType } from './extract';

export abstract class TimeSeries extends Extract {

  type = ExtractType.TIMESERIES;
  config: { split?: 'TECHNOLOGY' | 'PROVIDER' } = { split: 'TECHNOLOGY' };
  chartType = 'line';
}
